export default status => {
  if (status === 'WARNING') {
    return '#888888';
  } if (status === 'SUCCESS') {
    return '#888888';
  } return '#888888';
};
